import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { SunSpinner } from '@sunrun/component-library';

const StyledLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: rgba(0, 26, 60, 0.9);

  p {
    margin-top: 20px;
    text-align: center;
    font-family: Roobert, sans-serif;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: white;
  }
`;

const ContainerLoading = ({ copy }) => (
  <StyledLoader data-testid="full-screen-loader">
    <SunSpinner sunSize="5" raySize="0.75" />
    {copy && <p>{copy}</p>}
  </StyledLoader>
);

ContainerLoading.propTypes = {
  copy: PropTypes.string,
};

ContainerLoading.defaultProps = {
  copy: '',
};

export default ContainerLoading;
